import { Nav } from "react-bootstrap";
import "./CatalogIndex.css";

export interface PageTab {
  key: string;
  label: string;
  count?: number | null;
}

export interface PageTabsProps {
  activeKey: string;
  onSelect: (key: string) => void;
  tabs: PageTab[];
}

const renderLabel = (label: string, count: PageTab["count"]) =>
  count == null ? label : `${label} (${count})`;

export const PageTabs = ({ activeKey, onSelect, tabs }: PageTabsProps) => (
  <Nav
    variant="underline"
    activeKey={activeKey}
    onSelect={(key) => onSelect(key ?? activeKey)}
    role="tablist"
    className="pageTabs"
  >
    {tabs.map((tab) => (
      <Nav.Item key={tab.key}>
        <Nav.Link
          eventKey={tab.key}
          role="tab"
          aria-selected={activeKey === tab.key}
          className="pageTabs-link"
        >
          {renderLabel(tab.label, tab.count)}
        </Nav.Link>
      </Nav.Item>
    ))}
  </Nav>
);
